import AnomalyAlertEvaluationView from './AnomalyAlertEvaluationView';

export default AnomalyAlertEvaluationView;
